import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { MainState } from './state';

const defaultState: MainState = {
  isLoggedIn: null,
  token: '',
  logInError: false,
  userProfile: null,
  dashboardMiniDrawer: false,
  dashboardShowDrawer: true,
  notifications: [],
  navItems: [{text: 'Home', disabled: false, to: 'main'}],
  fileNotifications: 0,
  creatingArchive: false,
};

export const mainModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
